import { Injectable } from '@angular/core';
import { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MailingHelpdeskService extends BaseService {
  protected baseUrl = '/basis/notification/mailing-helpdesk';

  public getHelpdeskContacts(): Observable<ExternalUserFindInterface[]> {
    return this.http.get<ExternalUserFindInterface[]>(`${this.baseUrl}/contacts`);
  }

  public getHelpdeskUsers(): Observable<UserFindInterface[]> {
    return this.http.get<UserFindInterface[]>(`${this.baseUrl}/users`);
  }
}
